import { useContext } from 'react';
import {
  ListSubheader,
  alpha,
  Box,
  List,
  styled,
  Button,
  ListItem
} from '@mui/material';
import { NavLink as RouterLink } from 'react-router-dom';
import { SidebarContext } from 'src/contexts/SidebarContext';

import AddIcon from '@mui/icons-material/Add';
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import ViewListIcon from '@mui/icons-material/ViewList';
import AccountCircleTwoToneIcon from '@mui/icons-material/AccountCircleTwoTone';
import DisplaySettingsTwoToneIcon from '@mui/icons-material/DisplaySettingsTwoTone';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents'; // Trophy icon for competitions
import LocationOnIcon from '@mui/icons-material/LocationOn';

const MenuWrapper = styled(Box)(
  ({ theme }) => `
  .MuiList-root {
    padding: ${theme.spacing(1)};
  }

  .MuiListSubheader-root {
    text-transform: uppercase;
    font-weight: bold;
    font-size: ${theme.typography.pxToRem(12)};
    color: ${theme.colors.alpha.trueWhite[50]};
    padding: ${theme.spacing(0, 2.5)};
    line-height: 1.4;
  }
`
);

const SubMenuWrapper = styled(Box)(
  ({ theme }) => `
    .MuiList-root {
      .MuiListItem-root {
        padding: 1px 0;
        
        .MuiButton-root {
          display: flex;
          color: ${theme.colors.alpha.trueWhite[70]};
          background-color: transparent;
          width: 100%;
          justify-content: flex-start;
          padding: ${theme.spacing(1.2, 3)};
          .MuiButton-startIcon {
            color: ${theme.colors.alpha.trueWhite[30]};
            font-size: ${theme.typography.pxToRem(20)};
            margin-right: ${theme.spacing(1)};
          }
        }

        &.active,
        &:hover {
          background-color: ${alpha(theme.colors.alpha.trueWhite[100], 0.06)};
          color: ${theme.colors.alpha.trueWhite[100]};

          .MuiButton-startIcon {
            color: ${theme.colors.alpha.trueWhite[100]};
          }
        }
      }
    }
`
);

function SidebarMenu() {
  const { closeSidebar } = useContext(SidebarContext);

  return (
    <MenuWrapper>
      {/* MAIN MENU */}
      <List
        component="div"
        subheader={
          <ListSubheader component="div" disableSticky>
            Main Menu
          </ListSubheader>
        }
      >
        <SubMenuWrapper>
          <List component="div">
            <ListItem component="div">
              <Button
                disableRipple
                component={RouterLink} 
                onClick={closeSidebar}
                to="/"
                startIcon={<HomeIcon />}
              >
                Home
              </Button>
            </ListItem>
            <ListItem component="div">
              <Button
                disableRipple
                component={RouterLink}
                onClick={closeSidebar}
                to="/browse"
                startIcon={<LocationOnIcon />}
              >
                Discover Spots
              </Button>
            </ListItem>
            <ListItem component="div">
              <Button
                disableRipple
                component={RouterLink}
                onClick={closeSidebar}
                to="/images/view"
                startIcon={<ViewListIcon />}
              >
                My Spots
              </Button>
            </ListItem>
            <ListItem component="div">
              <Button
                disableRipple
                component={RouterLink}
                onClick={closeSidebar}
                to="/competitions"
                startIcon={<EmojiEventsIcon />}
              >
                Competitions
              </Button>
            </ListItem>
          </List>
        </SubMenuWrapper>
      </List>

      {/* ACTIONS */}
      <List
        component="div"
        subheader={
          <ListSubheader component="div" disableSticky>
            Actions
          </ListSubheader>
        }
      >
        <SubMenuWrapper>
          <List component="div">
            <ListItem component="div">
              <Button
                disableRipple
                component={RouterLink}
                onClick={closeSidebar}
                to="/images/addsingle"
                startIcon={<AddIcon />}
              >
                Add Catch Report
              </Button>
            </ListItem>
          </List>
        </SubMenuWrapper>
      </List>

      {/* ACCOUNT */}
      <List
        component="div"
        subheader={
          <ListSubheader component="div" disableSticky>
            Account
          </ListSubheader>
        }
      >
        <SubMenuWrapper>
          <List component="div">
            <ListItem component="div">
              <Button
                disableRipple
                component={RouterLink}
                onClick={closeSidebar}
                to="/accounts/profile"
                startIcon={<AccountCircleTwoToneIcon />}
              >
                Profile
              </Button>
            </ListItem>
            <ListItem component="div">
              <Button
                disableRipple
                component={RouterLink}
                onClick={closeSidebar}
                to="/accounts/dashboard"
                startIcon={<DisplaySettingsTwoToneIcon />}
              >
                Dashboard
              </Button>
            </ListItem>
          </List>
        </SubMenuWrapper>
      </List>

      {/* HELP */}
      <List
        component="div"
        subheader={
          <ListSubheader component="div" disableSticky>
            Help
          </ListSubheader>
        }
      >
        <SubMenuWrapper>
          <List component="div">
            <ListItem component="div">
              <Button
                disableRipple
                component={RouterLink}
                onClick={closeSidebar}
                to="/about"
                startIcon={<InfoIcon />}
              >
                About
              </Button>
            </ListItem>
            <ListItem component="div">
              <Button
                disableRipple
                component={RouterLink}
                onClick={closeSidebar}
                to="/feedback"
                startIcon={<MailOutlineIcon />}
              >
                Contact Us
              </Button>
            </ListItem>
          </List>
        </SubMenuWrapper>
      </List>
    </MenuWrapper>
  );
}

export default SidebarMenu;
